// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateEditAssetClassModal-module__title--1Rw9N","text":"CreateEditAssetClassModal-module__text--GDLli","label":"CreateEditAssetClassModal-module__label--2SqbK"};